import { EventCardListing } from 'components/eventCard/eventCardListing'
import { PlaceholderContainer } from 'components/placeholder'
import { useDateNavigation } from 'hooks/user/useEvents/useDateNavigation'
import { useFilteredEvents } from 'hooks/user/useEvents/useFilteredEvents'
import { Fragment, useEffect, useState } from 'react'
import { EventType } from 'types/Event'

import { LocationFilter } from './components/locationFilter'
import { SelectMonth } from './components/selectMonth'
import { Container, ContainerWrapper } from './eventListUser.style'

interface Props {
    data: EventType[]
}

export const EventListUser = ({ data }: Props) => {
    const initialDate = getInitialMonthFromEvents(data)

    const { selectedDate, handlePreviousMonth, handleNextMonth } = useDateNavigation(initialDate)

    const [selectedLocation, setSelectedLocation] = useState<string | null>(null)

    useEffect(() => {
        setSelectedLocation(null)
    }, [selectedDate])

    const { filteredEvents, availableLocations } = useFilteredEvents({
        data,
        selectedDate,
        selectedLocation,
    })

    return (
        <Container>
            <ContainerWrapper>
                <SelectMonth selectedDate={selectedDate} onPreviousMonth={handlePreviousMonth} onNextMonth={handleNextMonth} />
                <LocationFilter
                    selectedDate={selectedDate}
                    selectedLocation={selectedLocation}
                    setSelectedLocation={setSelectedLocation}
                    availableLocations={availableLocations}
                />
                {filteredEvents.length > 0 ? (
                    filteredEvents.map((current) => (
                        <Fragment key={current.event_id}>
                            <EventCardListing eventId={current.event_id} />
                        </Fragment>
                    ))
                ) : (
                    <PlaceholderContainer>
                        <p>Jelenleg nincs elérhető esemény ebben a hónapban. Hamarosan új események érkeznek!</p>
                    </PlaceholderContainer>
                )}
            </ContainerWrapper>
        </Container>
    )
}

const getInitialMonthFromEvents = (events: EventType[]): Date => {
    const now = new Date()

    // Find events whose event_date is after *right now*
    const futureEvents = events
        .map((e) => new Date(e.event_date))
        .filter((eventDate) => eventDate.getTime() > now.getTime())
        .sort((a, b) => a.getTime() - b.getTime())

    console.log('Future events dates:', futureEvents)
    if (futureEvents.length > 0) {
        const first = futureEvents[0]
        return new Date(first.getFullYear(), first.getMonth(), 1)
    }

    // fallback: current month
    return new Date(now.getFullYear(), now.getMonth(), 1)
}
